import { useState } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useOverlayContext } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import { errorTextsPath } from '~/infra/error-response/ErrorResponse';
import { RelationshipErrorResponse } from '~/infra/error-response/RelationshipErrorResponse';
import { handlePromise } from '~/infra/utils';
import { serviceModel } from '~/models';
import { useStoreActions } from '~/store/store-context';
export const { UseUpdateDraftTID } = getTestIds();
export function useUpdateDraft() {
    const { api } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const { t: errorTexts } = useLocaleKeys(errorTextsPath);
    const { showErrorToast } = useOverlayContext();
    const { STANFORD_TAX_INTEGRATION } = useFeatureFlags();
    const [loading, setLoading] = useState(false);
    return {
        loading,
        async updateDraft (param) {
            let { newDraft, onSuccess, onStartLoader, onStopLoader } = param;
            onStartLoader && onStartLoader();
            setLoading(true);
            const draftToSave = STANFORD_TAX_INTEGRATION ? serviceModel.withStanfordTaxEntries(newDraft.toDTO(), newDraft.serviceInstances()) : newDraft.toDTO();
            const result = await handlePromise(api.draft.save(draftToSave));
            onStopLoader && onStopLoader();
            setLoading(false);
            if (result.success) {
                onSuccess();
            } else {
                const relationshipError = new RelationshipErrorResponse(result.error);
                const message = relationshipError.isSignatureRefusal() ? relationshipError.message(errorTexts, newDraft.legalTermsDocuments()) : commonTexts.toasts.failedToUpdateDraft();
                showErrorToast(message, UseUpdateDraftTID.ErrorToast());
            }
        }
    };
}
